import {
  START_GET_GROUP_LIST,
  SUCCESS_GET_GROUP_LIST,
  ERROR_GET_GROUP_LIST,
  START_GET_PATIENT_FIELD_LIST,
  SUCCESS_GET_PATIENT_FIELD_LIST,
  ERROR_GET_PATIENT_FIELD_LIST,
  START_CREATE_GROUP,
  SUCCESS_CREATE_GROUP,
  ERROR_CREATE_GROUP,
  START_UPDATE_GROUP,
  SUCCESS_UPDATE_GROUP,
  ERROR_UPDATE_GROUP,
  START_DELETE_GROUP,
  SUCCESS_DELETE_GROUP,
  ERROR_DELETE_GROUP,
  START_GET_SINGLE_GROUP,
  SUCCESS_GET_SINGLE_GROUP,
  ERROR_GET_SINGLE_GROUP,
  SUCCESS_UPDATE_ORDERDATE_GROUP,
  ERROR_UPDATE_ORDERDATE_GROUP,
  START_UPDATE_ORDERDATE_GROUP,
} from "Actions/GroupAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  getGroupListAPI,
  createGroupAPI,
  updateGroupAPI,
  updateOrderDateGroupAPI,
  deleteSurGroupAPI,
  getSingleGroup,
  getPatientListAPI,
} from "Api/GroupApis";
import { call, put, takeEvery } from "redux-saga/effects";

function* getGroupListWorker({ payload }) {
  try {
    const res = yield call(getGroupListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_GROUP_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_GROUP_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createGroupWorker({ payload }) {
  try {
    const res = yield call(createGroupAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_GROUP,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Group Added Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_GROUP,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getPatientWorker({ payload }) {
  try {
    const res = yield call(getPatientListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PATIENT_FIELD_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PATIENT_FIELD_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateOrderDateGroupWorker({ id, payload }) {
  try {
    const res = yield call(updateOrderDateGroupAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_ORDERDATE_GROUP,
        payload: res,
        id: id,
      });
    } else {
      yield put({
        type: ERROR_UPDATE_ORDERDATE_GROUP,
        payload: res,
      });
    }
  } catch (error) {}
}
function* updateGroupWorker({ id, payload }) {
  try {
    const res = yield call(updateGroupAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_GROUP,
        payload: res,
        id: id,
      });
    } else {
      yield put({
        type: ERROR_UPDATE_GROUP,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deleteGroupWorker({ id }) {
  try {
    const res = yield call(deleteSurGroupAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_GROUP,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Group Deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_GROUP,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getSingleGroupWorker({ id }) {
  try {
    const res = yield call(getSingleGroup, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SINGLE_GROUP,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SINGLE_GROUP,
        payload: res,
      });
    }
  } catch (error) {}
}

export function* GroupSaga() {
  yield takeEvery(START_GET_GROUP_LIST, getGroupListWorker);
  yield takeEvery(START_CREATE_GROUP, createGroupWorker);
  yield takeEvery(START_UPDATE_GROUP, updateGroupWorker);
  yield takeEvery(START_DELETE_GROUP, deleteGroupWorker);
  yield takeEvery(START_GET_SINGLE_GROUP, getSingleGroupWorker);
  yield takeEvery(START_GET_PATIENT_FIELD_LIST, getPatientWorker);
  yield takeEvery(START_UPDATE_ORDERDATE_GROUP, updateOrderDateGroupWorker);
}
